const SHORT = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'] as const
const LONG = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
] as const

export const MONTH_KEY_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/

export function toMonthKey(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, '0')}`
}

const parse = (key: string) => ({ year: Number(key.slice(0, 4)), month: Number(key.slice(5, 7)) })

/** Every month from `from` to `to`, both inclusive, as "YYYY-MM". Empty when `to` is before `from`. */
export function monthsBetween(from: string, to: string): string[] {
  const out: string[] = []
  let { year, month } = parse(from)
  const end = parse(to)
  while (year < end.year || (year === end.year && month <= end.month)) {
    out.push(toMonthKey(year, month))
    month += 1
    if (month > 12) {
      month = 1
      year += 1
    }
  }
  return out
}

/** "Nov 26" */
export function monthShortLabel(key: string): string {
  const { year, month } = parse(key)
  return `${SHORT[month - 1]} ${String(year).slice(2)}`
}

/** "11" — for charts too narrow for the short label. */
export function monthNumberLabel(key: string): string {
  return key.slice(5, 7)
}

/** "November 2026" */
export function monthLongLabel(key: string): string {
  const { year, month } = parse(key)
  return `${LONG[month - 1]} ${year}`
}

/** The last calendar day of the month, "YYYY-MM-DD". */
export function lastDayOfMonth(key: string): string {
  const { year, month } = parse(key)
  const day = new Date(Date.UTC(year, month, 0)).getUTCDate()
  return `${key}-${String(day).padStart(2, '0')}`
}
